// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"index_searchContainer_2dn8Z","searchIcon":"index_searchIcon_CwTy4","loaderIcon":"index_loaderIcon_gSD9l","searchInput":"index_searchInput_24hAM"};